<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mb-2">
          <v-card-text>
            <v-row>
              <v-col>
                <small><b>{{ $t('guarantees.startDate') }}</b></small>
                <p>{{guarantee.startDate | formatDate}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.expiryDate') }}</b></small>
                <p>{{guarantee.expiryDate | formatDate}}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <small><b>{{ $t('guarantees.guarantorName') }}</b></small>
                <p>{{guarantee.guarantorName}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.guarantorRating') }}</b></small>
                <p>{{guarantee.guarantorRating}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.guarantorContractRating') }}</b></small>
                <p>{{guarantee.guarantorContractRating}}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="my-2">
          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="isEmployerGuarantee">
                <small><b>{{ $t('guarantees.physicalStorage') }}</b></small>
                <p>{{guarantee.physicalStorage}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.document') }}</b></small>
                <p>
                  <v-btn
                    v-if="guarantee.document.url"
                    icon
                    small
                    :href="guarantee.document.url"
                    target="_blank"
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                  <b>{{guarantee.document.description}}</b>
                </p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.internalContact') }}</b></small>
                <p>{{internalContact}}</p>
              </v-col>
            </v-row>
            <v-row v-if="!isEmployerGuarantee">
              <v-col>
                <small><b>{{ $t('guarantees.sentBack') }}</b></small>
                <p>{{guarantee.sentBack}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.externalContact') }}</b></small>
                <p>{{guarantee.externalContact}}</p>
              </v-col>
              <v-col>
                <small><b>{{ $t('guarantees.returnAddress') }}</b></small>
                <p>{{guarantee.returnAddress}}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col  cols="6" v-if="!!history.length">
        <v-card>
          <v-card-text>
            <v-row class="ma-0">
              <v-spacer />
              <v-btn
                small
                rounded
                color="primary"
                @click="handleProlongateGuarantee"
              >
                {{ $t('guarantees.prolongation') }}
              </v-btn>
            </v-row>
            <v-timeline
              align-top
              dense
            >
              <v-timeline-item
                v-for="(entry, i) in history"
                :key="i"
                small
              >
                <v-row>
                  <strong class="nowrap pa-2 mt-2">{{entry.createdAt | formatDate}}</strong>
                  <v-col>
                    <b><a :href="entry.url" target="_blank">{{entry.name}}</a></b>
                    <div class="text-caption font-weight-medium">
                      {{ $t(`guarantees.history.expiryDate`, { date: entry.expiryDate }) }}
                    </div>
                    <div class="text-caption">
                      {{ $t(`guarantees.history.${entry.comment.action}`, { name: entry.comment.user }) }}
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { DEFAULT_GUARANTEE, SITES, DEFAULT_CONTRACT } from '@/helpers'
import { mapState } from 'vuex'
import { getUser } from '@/services'
import dayjs from 'dayjs'

export default {
  name: 'GuaranteeDetails',
  props: {
    guarantee: {
      type: Object,
      default: () => (DEFAULT_GUARANTEE)
    },
    contract: {
      type: Object,
      default: () => (DEFAULT_CONTRACT)
    }
  },
  data () {
    return {
      internalContact: ''
    }
  },
  async created () {
    const internalContact = await getUser(this.guarantee.internalContact)
    this.internalContact = internalContact ? internalContact.displayName : this.guarantee.internalContact
  },
  computed: {
    ...mapState({
      statusesMap: (state) => state.statuses
        .filter(i => i.show.includes('guarantee'))
        .reduce((acc, curr) => ({ ...acc, [curr.code]: curr }), {})
    }),
    isEmployerGuarantee () {
      return this.guarantee.site === SITES.employer
    },
    percent () {
      return Math.floor((this.guarantee.securedAmountCents / this.contract.signedPriceCents) * 100)
    },
    history () {
      return this.guarantee.documents.map(i => {
        return {
          ...i,
          ...i.guarantee_documents,
          expiryDate: dayjs(i.documentExpiryDate).format('DD-MM-YYYY'),
          guarantee_documents: undefined
        }
      })
    }
  },
  methods: {
    handleProlongateGuarantee () {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'ProlongationForm',
        options: { maxWidth: 650 },
        scope: {
          guarantee: this.guarantee
        },
        handlers: {
          update: this.$emit('FETCH_DATA')
        }
      })
    }
  }
}
</script>
